<template>
    <div class="a-body">
        <!-- Header -->
        <h1 class="tl-text">TFYO TIMELINE</h1>
        <section class="a-section">
            <div class="first-sec">
                <!-- 1st Event -->
                <div class="first-box">
                    <div class="div1">
                        <img src="@/assets/announcements-img/news1.png" class="news-img" />
                        <div class="div2">
                            <p class="p6"> TFYO BrigadaTechSkwela: Nueva Ecija </p>
                            <p class="p7"> In partnership with @kathalifestylestore, our team visited one of the public
                                elementary schools far north to provide 20 tablets to chosen students.
                            </p>
                        </div>
                    </div>
                </div>
                <!-- 2nd Event -->
                <div class="first-box">
                    <div class="div1">
                        <img src="@/assets/announcements-img/news2.png" class="news-img" />
                        <div class="div2">
                            <p class="p6"> Transparency Report: MusiKabataan </p>
                            <p class="p7"> Transparency Report from our first ever live benefit concert held at Calor
                                Membership Lounge, which garnered Php 377,750 donations and Php 36, 750 ticket sales.
                            </p>
                        </div>
                    </div>
                </div>
                <!-- 3rd Event -->
                <div class="first-box">
                    <div class="div1">
                        <img src="@/assets/announcements-img/news3.png" class="news-img" />
                        <div class="div2">
                            <p class="p6"> TFYO BrigadaTechSkwela: Pampangga </p>
                            <p class="p7"> San Isidro National High School and San Roque Elementary School are two of
                                the public schools we helped as part of our Brigada Techskwela Project for Nueva Ecija.
                            </p>
                        </div>
                    </div>
                </div>
                <!-- 4th Event -->
                <div class="first-box">
                    <div class="div1">
                        <img src="@/assets/announcements-img/news4.png" class="news-img" />
                        <div class="div2">
                            <p class="p6"> Rita Daniela at Musikabataan </p>
                            <p class="p7"> 2 days ago, MusiKabataan was held at the local park. The event featured
                                various artists and one of the performers was Rita Daniela who impressed the audience
                                with her powerful voice. </p>
                        </div>
                    </div>
                </div>
                <!-- 5th Event -->
                <div class="first-box">
                    <div class="div1">
                        <img src="@/assets/announcements-img/news5.png" class="news-img" />
                        <div class="div2">
                            <p class="p6"> MusiKabataan Benefit Concert </p>
                            <p class="p7"> A night of solidarity, most awaited performances and mind-blowing prod.
                                Witness how these generous and amazing artists join together to give hope to our
                                Filipino youth! </p>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="second-sec">
                <!-- 6th Event -->
                <div class="first-box">
                    <div class="div1">
                        <img src="@/assets/announcements-img/news6.png" class="news-img" />
                        <div class="div2">
                            <p class="p6"> PascoLove 2021 </p>
                            <p class="p7"> It’s the time of the year! Come and join us tomorrow at 4pm as we celebrate
                                this Yuletide season with our talented Filipino artists. </p>
                        </div>
                    </div>
                </div>
                <!-- 7th Event -->
                <div class="first-box">
                    <div class="div1">
                        <img src="@/assets/announcements-img/news7.png" class="news-img" />
                        <div class="div2">
                            <p class="p6"> TFYO Summer Concert </p>
                            <p class="p7"> Join us on Kumu today and watch us on techforfilipinoyouth as we hold a
                                benefit concert to raise more funds for tablets!</p>
                        </div>
                    </div>

                </div>
                <!-- 8th Event -->
                <div class="first-box">
                    <div class="div1">
                        <img src="@/assets/announcements-img/news8.png" class="news-img" />
                        <div class="div2">
                            <p class="p6"> Summer Camp Benefit Concert </p>
                            <p class="p7"> To wrap up the end of our summer camp, join us tomorrow for a benefit concert
                                to celebrate our beneficiaries! Along with our special guests, our students will
                                showcase what they have learn. </p>
                        </div>
                    </div>

                </div>
                <!-- 9th Event -->
                <div class="first-box">
                    <div class="div1">
                        <img src="@/assets/announcements-img/news9.png" class="news-img" />
                        <div class="div2">
                            <p class="p6">TFYO Volunteer Recruitment </p>
                            <p class="p7"> Are you interested in volunteering with us? Click the 'Join Us' button in the
                                navigation bar and check the positions available to start a life changing journey with
                                us. </p>
                        </div>
                    </div>

                </div>
                <!-- 10th Event -->
                <div class="first-box">
                    <div class="div1">
                        <img src="@/assets/announcements-img/news10.png" class="news-img" />
                        <div class="div2">
                            <p class="p6"> TFYO Summer Camp 2021 </p>
                            <p class="p7"> TFYO presents Summer Camp 2021! Inaayayahan namin ang bawat estudyante na
                                magpa-rehistro sa aming libreng programa na magsisimula ng June 19! Check our homepage
                                for the available events. </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style scoped src="@/assets/css/globalStyle.css"></style>
<style scoped src="@/assets/css/timeline.css"></style>
